import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  separator: {
    height: 2,
    border: "none",
    boxShadow: "0px 1px 1px rgb(0 0 0 / 10%)",
    margin: 0,
  },
});